import NamedDto from 'modules/base/dto/NamedDto';

export class HysysModelOutputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.spreadsheet = null;
		/** @type {string} */
		this.cell = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.expression = null;
		/** @type {string} */
		this.stream = null;
		/** @type {boolean} */
		this.useUom = null;
		/** @type {number} */
		this.orderIndex = null;
		/** @type {string} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _HysysModelOutputAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} spreadsheet
	 * @property {string} cell
	 * @property {string} uom
	 * @property {string} expression
	 * @property {string} stream
	 * @property {boolean} useUom
	 * @property {number} orderIndex
	 * @property {string} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _HysysModelOutputAttributeEditDtoProps} HysysModelOutputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {HysysModelOutputAttributeEditDtoProps} props
	 * @returns {HysysModelOutputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.spreadsheet = props.spreadsheet;
		this.cell = props.cell;
		this.uom = props.uom;
		this.expression = props.expression;
		this.stream = props.stream;
		this.useUom = props.useUom || false;
		this.orderIndex = props.orderIndex;
		this.value = props.value;
		return this;
	}
}

export default HysysModelOutputAttributeEditDto;
